/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_Ranking_HintInputs */

const en_us2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off, nobody sees anyone else's number.`)
};

const pt_br2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligado, ninguém vê o número dos outros.`)
};

const es_419_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivado, nadie ve el número de los demás.`)
};

const pt_pt2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligada, ninguém vê o número dos outros.`)
};

const fr_fr2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé, personne ne voit le chiffre des autres.`)
};

const de_de2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus: Niemand sieht die Zahl der anderen.`)
};

const it_it2_clubs_field_ranking_hint = /** @type {(inputs: Clubs_Field_Ranking_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se disattivata, nessuno vede il numero degli altri.`)
};

/**
* | output |
* | --- |
* | "Off, nobody sees anyone else's number." |
*
* @param {Clubs_Field_Ranking_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_ranking_hint = /** @type {((inputs?: Clubs_Field_Ranking_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_Ranking_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_ranking_hint(inputs)
	if (locale === "es-419") return es_419_clubs_field_ranking_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_ranking_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_ranking_hint(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_ranking_hint(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_ranking_hint(inputs)
	return en_us2_clubs_field_ranking_hint(inputs)
});
export { clubs_field_ranking_hint as "clubs.field_ranking_hint" }